import * as React from "react";
import { helpers, Ui } from "@elrondnetwork/dapp-utils";

const RowCell = ({
  balance = "",
  valueUSD = "",
}: {
  balance?: string;
  valueUSD?: string;
}) => {
  return (
    <td className="score text-right">
      <div className="d-flex flex-column">
        <Ui.Denominate value={balance} showLabel={false} decimals={2} />
        <div className="text-secondary">{`$${helpers.usdValue({
          amount: valueUSD,
          usd: 1,
        })}`}</div>
      </div>
    </td>
  );
};

export default RowCell;
